'use client';

import Image from 'next/image';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import emptyCartSvg from '@/assets/cart/empty-cart.svg?url';
import { Typography } from '@/components/ui/typography/typography.component';

interface CartEmptyStateProps {
  onSearch: () => void;
}

export function CartEmptyState({ onSearch }: CartEmptyStateProps) {
  return (
    <section
      className="flex min-h-full flex-col items-center justify-center px-6 text-center"
      data-testid={DataTestIdEnum.CART_EMPTY_STATE}
    >
      <Image src={emptyCartSvg} alt="Carrinho vazio" width={159} height={145} draggable={false} />

      <Typography
        className="mt-3 font-bold text-gray-800"
        data-testid={DataTestIdEnum.CART_EMPTY_STATE_TITLE}
      >
        Nenhum item no seu carrinho.
      </Typography>

      <Typography
        className="mt-2 text-gray-700"
        data-testid={DataTestIdEnum.CART_EMPTY_STATE_DESCRIPTION}
      >
        Adicione procedimentos para cuidar da sua saúde.
      </Typography>

      <Button
        startIcon={faMagnifyingGlass}
        startIconSize="1x"
        className="mt-6 h-12 w-full text-base"
        onClick={onSearch}
        data-testid={DataTestIdEnum.CART_EMPTY_STATE_SEARCH_BUTTON}
      >
        Fazer uma busca
      </Button>
    </section>
  );
}
